import moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { formatLinkString } from "../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faClock, faCalendarAlt, faUsers } from "@fortawesome/free-solid-svg-icons";
import "./styleCard.css"; // Assurez-vous d'ajouter le CSS ci-dessous

const JobCard = (props) => {
  const { job } = props;
  const { t } = useTranslation();

  return (
    <div className="card-job-modern hover-up">
      <Link to={`/job/${job.slug}/details/`} className="d-block h-100">
        
        {/* En-tête : Logo + Badges */}
        <div className="card-job-header">
           <div className="card-job-image-box">
             <img
                src={job?.image ? formatLinkString(job?.image) : "/assets/imgs/page/homepage2/logo.png"}
                alt={job.title}
                className="img-fluid"
             />
           </div>
           <div className="card-job-badges">
             {job.type && <span className="badge-job badge-blue">{job.type}</span>}
             {job.closed && <span className="badge-job badge-red">{t("jobExpired")}</span>}
           </div>
        </div>

        {/* Corps : Titre et Infos */}
        <div className="card-job-body">
            <h5 className="job-title text-truncate-2" title={job.title}>
                {job.title}
            </h5>
            
            {/* Meta infos avec icônes */}
            <div className="job-meta-list">
                <div className="meta-item">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="icon-muted" />
                    <span>{job.city?.name || job.country?.name || "Localisation non précisée"}</span>
                </div>
                <div className="meta-item">
                     <FontAwesomeIcon icon={faClock} className="icon-muted" />
                     <span>{moment(job?.created_at).fromNow()}</span>
                </div>
            </div>

            {/* Tags / Compétences */}
            <div className="job-tags-container">
                 {job?.skills?.slice(0, 3)?.map((skill) => (
                    <span key={skill.id} className="job-tag-pill">{skill.name}</span>
                 ))}
            </div>
            
            {/* Description courte (tronquée par CSS) */}
            <div 
                className="job-desc-preview"
                dangerouslySetInnerHTML={{ __html: job.description }}
            ></div>
        </div>

        {/* Pied de carte : Stats et Date limite */}
        <div className="card-job-footer">
             <div className="d-flex justify-content-between align-items-center w-100">
                <div className="footer-stat" title={t("textNberAppl")}>
                    <FontAwesomeIcon icon={faUsers} className="me-1 text-primary" />
                    {job.submitted} <span className="d-none d-sm-inline">Candidats</span>
                </div>
                <div className="footer-date text-danger">
                    <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                    {moment(job?.application_end).format("DD MMM")}
                </div>
             </div>
        </div>

      </Link>
    </div>
  );
};

export default JobCard;